<template>
  <div class="wrap" v-if="loading">
    <img src="/static/img/loading.gif" alt="" class="loadingIMg" />
  </div>
</template>

<script>
  export default {
    data() {
      return {
        loading: false,
      };
    },
  };

</script>

<style lang="less" scoped="scoped">
  .wrap {
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;

    .loadingIMg {
      width: 55px;
      height: 55px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/plugins/loading/loading.vue